import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allEntNivelesAcademicosAction,
  setActivoEntNivelesAcademicosAction,
} from './EntNivelesAcademicosAction';
import FormEntNivelesAcademicos from './components/FormEntNivelesAcademicos';
import ListadoEntNivelesAcademicos from './components/ListadoEntNivelesAcademicos';

const EntNivelesAcademicosView = () => {
  const dispatch = Redux.useDispatch();

  const entNivelesAcademicosStore = Redux.useSelector(
    (state) => state.entNivelesAcademicos,
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoEntNivelesAcademicosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          addIcon
          green
          mr={2}
        />
        {entNivelesAcademicosStore.all.length > 0 && (
          <BotonComponent
            click={async () => {
              await setActivoEntNivelesAcademicosAction(dispatch, null);
              await allEntNivelesAcademicosAction(
                dispatch,
                entNivelesAcademicosStore.params,
              );
            }}
            refreshIcon
            disabled={entNivelesAcademicosStore.loadingAll}
            white
            text={
              entNivelesAcademicosStore.loadingAll
                ? 'Actualizando...'
                : 'Actualizar'
            }
          />
        )}
      </Grid>
      <Grid item md={12}>
        <ListadoEntNivelesAcademicos
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <ModalComponent
        id="modalFormEntNivelesAcademicos"
        title="Asignar nivel académico"
        open={openModalForm}
        maxWidth="lg"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormEntNivelesAcademicos
          activo={entNivelesAcademicosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default EntNivelesAcademicosView;
